import { CERoleAttributesBase } from './ce-role-attributes-base'


export class CERoleAttributes extends CERoleAttributesBase {

}